import { useEffect, useState } from "react";

import { AWSPlace, geoCode } from "/geoservice";

import { GeoCoordinates } from "./types";

export type useMapLocationProps = {
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  phoneNumber?: string | null;
  enabled?: boolean;
};
export type GeoLocation = {
  coordinate: GeoCoordinates;
};

export type MapLocation = {
  location?: GeoLocation;
  isLoading: boolean;
};

const useMapLocation = ({
  address,
  city,
  state,
  zip,
  phoneNumber,
}: useMapLocationProps): MapLocation => {
  const [mapLocation, setMapLocation] = useState<MapLocation>({
    isLoading: true,
  });

  useEffect(() => {
    async function fetchData() {
      const result: AWSPlace[] = await new Promise((resolve) => {
        geoCode(
          {
            address1: address ?? "",
            city: city ?? "",
            state: state ?? "",
            zipCode: zip ?? "",
          },
          (data) => {
            resolve(data);
          },
        );
      });

      if (result && result.length > 0) {
        const place = result[0];
        setMapLocation({
          location: {
            coordinate: {
              longitude: place.Position[0],
              latitude: place.Position[1],
            },
          },
          isLoading: false,
        });
      } else {
        setMapLocation({
          location: undefined,
          isLoading: false,
        });
      }
    }
    fetchData();
  }, [phoneNumber, address, city, state, zip]);

  return mapLocation;
};

export default useMapLocation;
